var exports = {
  "Qs": "RecipientList.module__content___ZUVnUm",
  "Rt": "RecipientList.module__searchInput___ZUVnUm",
  "qc": "RecipientList.module__searchIcon___ZUVnUm",
  "qI": "RecipientList.module__listContainer___ZUVnUm",
  "XG": "RecipientList.module__scroller___ZUVnUm",
  "wV": "RecipientList.module__noResults___ZUVnUm",
  "PR": "RecipientList.module__friendList___ZUVnUm",
  "eH": "RecipientList.module__friendItem___ZUVnUm",
  "j8": "RecipientList.module__friendItemLeft___ZUVnUm",
  "Hb": "RecipientList.module__friendInfo___ZUVnUm",
  "G3": "RecipientList.module__friendName___ZUVnUm",
  "hw": "RecipientList.module__friendSecondary___ZUVnUm",
  "hP": "RecipientList.module__actionButton___ZUVnUm",
};

module.exports = exports;
